import styled from "styled-components"
import { BREAKPOINTS } from "../GlobalTheme"

const Contaier = styled.div<{ $toggled: boolean, $isBorder?: boolean }>`
  width: 50px;
  height: 25px;
  background-color: ${props => props.$toggled ? props.theme.colors.primary : props.theme.colors.gray_300};
  border-radius: 25px;
  padding: 3px;

  /* The track must stay 25px tall to look right, so grow only the tappable area. ::after belongs to
     this element, so taps on it still fire the switch's own handler. */
  @media (max-width: ${BREAKPOINTS.shell}px) {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: -8px;
      bottom: -8px;
      left: -4px;
      right: -4px;
    }
  }
  cursor: pointer;
  transition: background-color .2s ease-in-out;
  outline: ${props => props.$isBorder ? '2px' : '0px'} solid ${props => props.$toggled ? props.theme.colors.primary : props.theme.colors.white};
`

const Slider = styled.div<{ $toggled: boolean }>`
  width: 25px;
  height: 25px;
  background-color: white;
  border-radius: 25px;
  box-shadow: 0px 3px 8px 0px #0000001A;
  margin-left: ${props => props.$toggled ? '25px' : '0px'};
  transition: margin-left .2s ease-in-out;
`

export default function Switch({ toggled, setToggled, isBorder, ariaLabel }: {toggled: boolean, setToggled: (value: boolean) => void, isBorder?: boolean, ariaLabel?: string }) {
  return (
    <Contaier
      role="switch"
      aria-checked={toggled}
      aria-label={ariaLabel}
      tabIndex={0}
      $toggled={toggled}
      onClick={() => setToggled(!toggled)}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setToggled(!toggled) } }}
      $isBorder={isBorder}>
      <Slider $toggled={toggled} />
    </Contaier>
  )
}